module.exports = __webpack_public_path__ + "static/media/chevron-up.4975195d.svg";